import { BaseBookingModel, FoodBookingModel, ViewTable } from '@xeetr/types/models'

type AggregatedField = {
  count: number
  values: Set<string>
  sum?: number
}

export const aggregateFields = (dayBookings: BaseBookingModel[], cateringFieldId?: string) => {
  const aggregated: Record<string, AggregatedField> = {}

  const pushField = (key: string, value: string, isSum = false, isCatering = false) => {
    const normalizedValue = value?.trim()
    if (!normalizedValue) return

    const existing = aggregated[key] ?? { count: 0, values: new Set<string>(), sum: isSum ? 0 : undefined }
    existing.count++
    existing.values.add(normalizedValue)

    if (isSum && !isCatering) {
      existing.sum = (existing.sum ?? 0) + (Number.parseInt(normalizedValue, 10) || 0)
    }

    aggregated[key] = existing
  }

  for (const booking of dayBookings) {
    const foodBooking = booking as FoodBookingModel
    const hasTables = Array.isArray(foodBooking.tables) && foodBooking.tables.length > 0

    if (hasTables) {
      pushField('Tische', foodBooking.tables.map((t: ViewTable) => t.name).join(', '))
    }

    if (foodBooking.amount != null) {
      const isCatering = Boolean(
        cateringFieldId &&
          foodBooking.bookingAdditions?.customFields?.[cateringFieldId]
      )
      pushField('Personen', String(foodBooking.amount), true, isCatering)
    }
  }

  return aggregated
}
